import React, {useState, useEffect}  from 'react';
import {Container, Alert, Table, Button} from 'react-bootstrap';
import {useNavigate, useParams} from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../../util/Api';
import {useSelector} from 'react-redux';
import {getUserAccounts} from '../../../app/slices/UserSlice';
import AccountInviteForm from './AccountInviteForm';

const AccountInviteList = (props) => {

  const [errors, setErrors] = useState([]);
  const [invites, setInvites] = useState([]);
  const [showInviteUser, setShowInviteUser] = useState(false);

  let {accountKey} = useParams();
  let navigate = useNavigate();

  let showErrors = props?.showErrors == true ? true: false; 
  //let includeInvite = props?.includeInvite == true ? true: false;
  let userCount = props?.userCount ? props.userCount : 0;
  //console.log('usercount:' + userCount)
  const currUserAccounts = useSelector(getUserAccounts);
  const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
  const currRoleId = currUserAccount ? currUserAccount.roleId : 0;
  const userLimit = currUserAccount ? currUserAccount.userLimit : 0;

  const updateInvites = (invites) => {   
    setErrors([])
    //check if over limit 
    if((userCount + invites.length) < userLimit){
        setShowInviteUser(true);
    }
    else {
        setShowInviteUser(false);
    }
    
    setInvites(invites);
  }

  const deleteInvite = (inviteId) => {
    let options = {
        accountKey: accountKey,
        inviteId: inviteId
    }
    axios.post(apiUrl + '/invites/delete',
      options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        let temp = [...invites];
        setInvites(temp.filter(invite => invite.inviteId != inviteId))
      } else {
        let errorMsgs = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            default:
              errorMsgs.push('There was an error deleting the invite.');
          }
        });
        setErrors(errorMsgs);
      }
    })
    .catch((err) => {

    });
  }

  useEffect(() => {

    if(currRoleId > 1 && userCount < userLimit) {
        //console.log(`users: ${userCount} limit: ${userLimit}`)
        setShowInviteUser(true);
    }

    let options = {
      accountKey: accountKey
    }
    let isAuthError = false;
    axios.post(apiUrl + '/invites/list',
      options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        if(Array.isArray(res.data.invites)){
            setInvites(res.data.invites);
            if((res.data.invites.length + userCount >= userLimit)){
              if(showInviteUser){
                setShowInviteUser(false)
              }
            } else {
              if(!showInviteUser){
                setShowInviteUser(true)
              }
            }
        }
        else {
          //nothing to show
        }
      } else {
        let errorMsgs = [];
        let redirectToLogin = false;
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'auth-expired':
            case 'auth-error':
            case 'no-auth':
            case 'no-valid-account':
            case 'no-permissions':
              //console.log('auth expired');
              isAuthError = true;
              //navigate('/login');
              //errorMsgs.push('You have been logged out.');
              //return;
              redirectToLogin = true;
              break;
            case 'no-results':
              //console.log('no results')
              errorMsgs.push('There are currently no outstanding invites.');
              break;
            default:
              errorMsgs.push('There was an error retrieving invites.');
          }
        });
        //don't call setErrors if not logged in as it throws an unmounted error
        if(redirectToLogin) {
          navigate('/login');
          return;
        }
        if(!isAuthError) {
          setErrors(errorMsgs);
        }
      }
    })
    .catch((err) => {

    });
  },[navigate, accountKey, userCount]);

  const sortByEmail = () => {
    //console.log('sorting name')
    let temp = [...invites]
    temp.sort((a,b) => (a.email < b.email) ? -1 : 1)
    setInvites(temp);
  }
  const sortByRole = () => {
    //console.log('sorting key')
    let temp = [...invites]
    temp.sort((a,b) => (a.role < b.role) ? -1 : 1)
    setInvites(temp);
  }
  const sortByDate = () => {
    //console.log('sorting date')
    let temp = [...invites]
    temp.sort((a,b) => (a.created < b.created) ? 1 : -1)
    setInvites(temp);
  }

  return (
        <div>

          {
            (errors.length > 0) ? (
              <Alert variant='primary'>
              {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
              </Alert>
            ) : (null)
          }
          {
            invites.length > 0 ? (
                <>
              <Table  hover>
                <thead>
                  <tr>
                    <th><span onClick={sortByEmail} role="button">Email</span></th>
                    <th><span onClick={sortByRole} role="button">Role</span></th>
                    <th><span onClick={sortByDate} role="button">Invited</span></th>
                    <th >actions</th>
                  </tr>
                </thead>
                <tbody>
                {
                  invites.map((invite, i) => (
                    <tr key={'invite.' + i}>
                      <td>{invite.email}</td>
                      <td>{invite.role}</td>
                      <td>{new Date(invite.created).toLocaleDateString()}</td>
                      <td><Button onClick={()=>{deleteInvite(invite.inviteId)}} variant='danger' size='sm'>remove</Button></td>
                    </tr>
                  ))
                }
                </tbody>
              </Table>
              
              </>
            ) : (
              null
            )
          }
          {
                showInviteUser ? (
                  <AccountInviteForm updateInvites={updateInvites} invites={invites} accountKey={accountKey} userLimit={userLimit} userCount={userCount} />
                ) : (
                  null
                )
             }
        </div>
  )
}

export default AccountInviteList;
